const indexItems = [
  { id: 1, title: '国剧经典', count: '326部', icon: 'ri-vip-crown-line' },
  { id: 2, title: '港台剧场', count: '189部', icon: 'ri-building-2-line' },
  { id: 3, title: '日韩热播', count: '254部', icon: 'ri-earth-line' },
  { id: 4, title: '欧美精选', count: '178部', icon: 'ri-global-line' },
  { id: 5, title: '古装权谋', count: '142部', icon: 'ri-sword-line' },
  { id: 6, title: '刑侦探案', count: '98部', icon: 'ri-search-eye-line' },
  { id: 7, title: '都市情感', count: '215部', icon: 'ri-heart-line' },
  { id: 8, title: '仙侠奇幻', count: '87部', icon: 'ri-magic-line' },
  { id: 9, title: '高分口碑', count: '163部', icon: 'ri-star-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            专题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            九大分类精准导航，快速找到您想看的剧集类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#hero"
              className="group flex items-center gap-3 md:gap-4 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-accent-300/50 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500">{item.count}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-accent-500 transition-colors ml-auto flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}